import { TextField, InputAdornment, IconButton } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { FormInputProps } from "../../types/formInputProps";

const Pass = ({ control, rules }: Omit<FormInputProps, 'label' | "name">) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <Controller
            name={'password'}
            control={control}
            render={({
                field: { onChange, value },
                fieldState: { error },
                formState,
            }) => (
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    helperText={error ? error.message : null}
                    size="small"
                    error={!!error}
                    onChange={onChange}
                    value={value ?? ""}
                    variant="outlined"
                    name="password"
                    label="Пароль"
                    type={showPassword ? "text" : "password"}
                    id="password"
                    autoComplete="current-password"
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setShowPassword(s => !s)}
                                    edge="end"
                                    size="small"
                                >
                                    {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    {...rules}
                />
            )}
        />
    );
};
export default Pass;